<template>
   <div class="popHeader">
       <div class="header">
           <i  class="mintui mintui-back"  @click="cancel"></i>
   
        {{title}}
           <div class="sureGear" ></div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            
        }
    },
    props: {
        title:String
    },
    mounted() {
      
    },
    methods: {
      cancel(){
         this.$emit("cancel");
      }
    },
    components: {
    }
}
</script>
<style lang='less' >
.popHeader {
    height: 1.066667rem;
    .header{
    line-height: 1.066667rem;
      font-size: 16px;
      text-align: center;

      position: fixed;
      height: 1.066667rem;
      width:100%;
      background: #393c41;
      color: #fff;
      text-align: center;
      border-bottom: 1px solid #eee;
      .mintui-back {
        line-height: 1.066667rem;
        font-size: .5rem;
        padding:0 0.2rem;
        float: left;
      }
      .sureGear {
        float: right;
        width: 1.2rem;
        height: 1rem;
      }
    }
}
</style>


// WEBPACK FOOTER //
// popHeader.vue?43527670